import { component } from 'picoapp'

export default component((node) => {
    const form = node.closest('form')
    const inputs = node.querySelectorAll('input')

    inputs.forEach((input) => {
        input.addEventListener('change', () => {
            form.submit()
        })
    })
})
